import { useTranslation } from '@mc/i18n'

import { InfoItems } from './components/InfoItems'
import { PurchaseCTA } from './components/PurchaseCTA'

export const SelfServe = ({ onCTAClicked }: { onCTAClicked: () => void }) => {
  const { t } = useTranslation('@mc/next')

  return (
    <section
      className={`uncontainer mc-bg-container-dark mc-py-9 d-flex justify-content-center mc-px-4 mc-px-md-0`}
      data-testid='self-serve-section'
    >
      <div
        className={`d-flex flex-wrap align-items-center`}
        style={{ gap: 'var(--mc-scale-6)' }}
      >
        <div className='flex-2 mc-p-8'>
          <h1 className={`mc-text-h1`}>{t('forBusiness.selfServe.title')}</h1>
          <p className='mc-opacity--hinted mc-mt-4'>
            {t('forBusiness.selfServe.description')}
          </p>
          <PurchaseCTA onCTAClicked={onCTAClicked} className='mc-mt-8' />
        </div>
        <div className='flex-1'>
          <InfoItems />
        </div>
      </div>
    </section>
  )
}
